export default "__VITE_ASSET__B7nq9sGA__"